type PageObject = {
  name: string
  description: string
}

type ImpactModulePages = {
  [key: string]: PageObject
}

export const MESSENGER_PAGES: ImpactModulePages = {
  GROUP_MODULE_PERMISSION: {
    name: 'Permissões de grupos',
    description: 'Gestão das permissões dos grupo',
  },
  PUBLIC_AGENT_MODULE_PERMISSION: {
    name: 'Permissões dos agentes',
    description: 'Gestão das permissões dos agentes públicos',
  },
}
